<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    offset-overflow
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        ref="dateRef"
        v-model="textDate"
        prepend-icon="mdi-calendar-month"
        :rules="rules"
        maxlength="7"
        :disabled="disabled"
        :readonly="readonly"
        :clearable="!required"
        :hint="hint"
        :persistentHint="persistentHint"
        @click:clear="dateClear"
        @input="inputChange"
        v-bind="attrs"
        v-on="on"
      >
        <template v-if="!hideLabel" #label>
          <span>{{ label }}</span>
          <span v-if="required && !hiddenRequiredIcon" class="error--text"> *</span>
          <span v-if="onlyShowRequiredNotCheck" class="error--text"> *</span>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      ref="datePicker"
      :max="max"
      @change="dateChange"
      type="month"
      v-model="pickDate"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "VDateMonth",
  data: () => ({
    menu: false,
    textDate: "",
    pickDate: "",
    fromToCheckRules: null
  }),
  model: {
    event: "selectedDate",
    prop: "actionDate"
  },
  props: {
    label: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    actionDate: {
      type: String
    },
    elderly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: undefined
    },
    max: {
      type: String,
      default: undefined
    },
    birthdayMode: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hiddenRequiredIcon: {
      type: Boolean,
      default: false
    },
    onlyShowRequiredNotCheck: {
      type: Boolean,
      default: false
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    fromToCheck: {}
  },
  watch: {
    actionDate: {
      handler() {
        this.textDate = this.actionDate;
      }
    },
    menu(val) {
      if (this.birthdayMode) {
        val && this.$nextTick(() => (this.$refs.datePicker.internalActivePicker = "YEAR"));
      }
      if (val) {
        if (this.$refs.dateRef.validate()) {
          this.pickDate = this.textDate;
        } else {
          this.pickDate = "";
        }
      }
    },
    fromToCheck: {
      handler() {
        this.fromToCheckRules = this.fromToCheck;
        this.$refs.dateRef.validate(true);
      }
    }
  },
  computed: {
    rules() {
      let result = [];
      if (!this.required) {
        result = [this.$getValidate("dateMonthFormat", this.label), this.$getValidate("maxlength", this.label, 7)];
      } else {
        result = [
          this.$getValidate("dateMonthFormat", this.label),
          this.$getValidate("required", this.label),
          this.$getValidate("maxlength", this.label, 7)
        ];
      }
      if (this.fromToCheckRules) {
        result.push(this.fromToCheckRules);
      }
      return result;
    }
  },
  methods: {
    dateChange(date) {
      this.textData = date;
      this.menu = false;
      this.$emit("selectedDate", date);
      this.$emit("change");
    },
    dateClear() {
      this.$emit("selectedDate", "");
      this.$emit("change");
    },
    inputChange(value) {
      this.$emit("selectedDate", value);
      this.$emit("change");
    }
  },
  created() {
    if (this.actionDate) {
      this.textDate = this.actionDate;
      this.pickDate = this.actionDate;
      this.fromToCheckRules = this.fromToCheck;
    }
  }
};
</script>

<style scoped></style>
